export const lemonScentedTea = {
    name: 'Lemon scented tea',
    logo: {
        path: 'partners/lemon-scented-tea-logo-white.svg',
        alt: 'Lemon scented tea logo',
    },
};
